import { Body, Icon, IconButton } from '@assembly-js/design-system';
import { Menu, MenuItem } from '@mui/material';
import { useMemo, useState } from 'react';

const OptionsMenu = ({
  onClearAddress,
  isEmptyAddress,
}: {
  onClearAddress: () => void;
  isEmptyAddress: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const optionsList = useMemo(() => {
    const options = [];
    if (!isEmptyAddress) {
      options.push(
        <MenuItem
          key="deleteAddress"
          className="flex items-center gap-2"
          onClick={() => {
            onClearAddress();
            setAnchorEl(null);
          }}
        >
          <Icon icon="Trash" className="w-3 h-3 text-red-primary" />
          <Body size="sm" className="text-red-primary">
            Delete address
          </Body>
        </MenuItem>,
      );
    }
    return options;
  }, [isEmptyAddress, onClearAddress]);

  if (optionsList.length === 0) return null;

  return (
    <>
      <IconButton
        className="w-6 h-6 p-0 flex items-center justify-center hover:bg-gray-100 *:w-4 *:h-4"
        icon="Ellipsis"
        label="options"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        variant="minimal"
      />
      <Menu
        open={anchorEl !== null}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        onClose={() => setAnchorEl(null)}
        classes={{
          paper:
            'border border-solid border-secondary-hover shadow-dropdown-menu',
        }}
      >
        {optionsList.map((optionItem) => optionItem)}
      </Menu>
    </>
  );
};

export default OptionsMenu;
